
import { GlobalColor } from "@builder/components/general/ColorInput";


export const colorPalleteTags = {
    light: {iconSrc: "sun-1"},
    dark: {iconSrc: "half-moon-1"},
}
export interface Palette {
    id: string;
    name: string;
    colors: GlobalColor[];
    featuredColorsPreview?: string[];
    tags: (keyof typeof colorPalleteTags)[];
}

export const palettes: Palette[] = [
  {
    id: "palette_final",
    name: "Final",
    tags: ["light"],
    featuredColorsPreview: [
        "global-color-66006",
        "global-color-64d5a",
        "global-color-c4936",
        "global-color-1c32a"
    ],
    colors: [
      {
        "id": "global-color-dc851",
        "name": "Border",
        "color": "#d4dee5"
      },
      {
        "id": "global-color-4c1f0",
        "name": "Light Error",
        "color": "#ff525f1a"
      },
      {
        "id": "global-color-2dc58",
        "name": "Error",
        "color": "#ff525f"
      },
      {
        "id": "global-color-108d4",
        "name": "Bg",
        "color": "#ffffff"
      },
      {
        "id": "global-color-1c32a",
        "name": "Section Background",
        "color": "#faf9fc"
      },
      {
        "id": "global-color-66006",
        "name": "Neutral primary",
        "color": "#3d4c66"
      },
      {
        "id": "global-color-1d200",
        "name": "Neutral secondary ",
        "color": "#758696"
      },
      {
        "id": "global-color-64d5a",
        "name": "Primary",
        "color": "#2797e8"
      },
      {
        "id": "global-color-c4936",
        "name": "Secondary",
        "color": "#e7f4fe"
      },
      {
        "id": "global-color-ad53f",
        "name": "Success",
        "color": "#47d2a5"
      },
      {
        "id": "global-color-245ed",
        "name": "Primary foreground text",
        "color": "#fff"
      },
      {
        "id": "global-color-19df8",
        "name": "Secondary foreground text",
        "color": "#2797e8"
      }
    ]
  },
  {
    id: "palette_light_pink",
    name: "Light Pink",
    tags: ["light"],
    featuredColorsPreview: [
        "global-color-66006",
        "global-color-64d5a",
        "global-color-c4936",
        "global-color-1c32a"
    ],
    colors: [
      {
        "id": "global-color-dc851",
        "name": "Border",
        "color": "#d9d1e0"
      },
      {
        "id": "global-color-4c1f0",
        "name": "Light error",
        "color": "#e03e431a"
      },
      {
        "id": "global-color-2dc58",
        "name": "Error",
        "color": "#e03e43"
      },
      {
        "id": "global-color-108d4",
        "name": "BG",
        "color": "#ffffff"
      },
      {
        "id": "global-color-1c32a",
        "name": "Background light grey",
        "color": "#faf9fc"
      },
      {
        "id": "global-color-66006",
        "name": "Neutral primary",
        "color": "#3d4c66"
      },
      {
        "id": "global-color-1d200",
        "name": "Neutral secondary",
        "color": "#758696"
      },
      {
        "id": "global-color-64d5a",
        "name": "Primary",
        "color": "#db6595"
      },
      {
        "id": "global-color-c4936",
        "name": "Secondary",
        "color": "#fae4f1"
      },
      {
        "id": "global-color-ad53f",
        "name": "Success",
        "color": "#4ea215"
      },
      {
        "id": "global-color-245ed",
        "name": "Primary foreground text",
        "color": "#fff"
      },
      {
        "id": "global-color-19df8",
        "name": "Secondary foreground text",
        "color": "#944463"
      }
    ]
  },
  {
    id: "palette_light_orange",
    name: "Light Orange",
    tags: ["light"],
    featuredColorsPreview: [
        "global-color-66006",
        "global-color-64d5a",
        "global-color-c4936",
        "global-color-1c32a"
    ],
    colors: [
      {
        "id": "global-color-dc851",
        "name": "Border",
        "color": "#d9d1e0"
      },
      {
        "id": "global-color-4c1f0",
        "name": "Light error",
        "color": "#ff525f33"
      },
      {
        "id": "global-color-2dc58",
        "name": "Error",
        "color": "#ff525f"
      },
      {
        "id": "global-color-108d4",
        "name": "BG",
        "color": "#ffffff"
      },
      {
        "id": "global-color-1c32a",
        "name": "Background light grey",
        "color": "#faf9fc"
      },
      {
        "id": "global-color-66006",
        "name": "Neutral primary",
        "color": "#110a1f"
      },
      {
        "id": "global-color-1d200",
        "name": "Neutral secondary",
        "color": "#758696"
      },
      {
        "id": "global-color-64d5a",
        "name": "Primary",
        "color": "#f26321"
      },
      {
        "id": "global-color-c4936",
        "name": "Secondary",
        "color": "#fdeee4"
      },
      {
        "id": "global-color-ad53f",
        "name": "Success",
        "color": "#47d2a5"
      },
      {
        "id": "global-color-245ed",
        "name": "Primary foreground text",
        "color": "#fff"
      },
      {
        "id": "global-color-19df8",
        "name": "Secondary foreground text",
        "color": "#f26321"
      }
    ]
  },
  {
    id: "palette_light_green",
    name: "Light Green",
    tags: ["light"],
    featuredColorsPreview: [
        "global-color-66006",
        "global-color-64d5a",
        "global-color-c4936",
        "global-color-1c32a"
    ],
    colors: [
      {
        "id": "global-color-dc851",
        "name": "Border",
        "color": "#d9d1e0"
      },
      {
        "id": "global-color-4c1f0",
        "name": "Light error",
        "color": "#ff525f33"
      },
      {
        "id": "global-color-2dc58",
        "name": "Error",
        "color": "#ff525f"
      },
      {
        "id": "global-color-108d4",
        "name": "BG",
        "color": "#ffffff"
      },
      {
        "id": "global-color-1c32a",
        "name": "Background light grey",
        "color": "#faf9fc"
      },
      {
        "id": "global-color-66006",
        "name": "Neutral primary",
        "color": "#3d4c66"
      },
      {
        "id": "global-color-1d200",
        "name": "Neutral secondary",
        "color": "#758696"
      },
      {
        "id": "global-color-64d5a",
        "name": "Primary",
        "color": "#3a6b2f"
      },
      {
        "id": "global-color-c4936",
        "name": "Secondary",
        "color": "#f2f7f0"
      },
      {
        "id": "global-color-ad53f",
        "name": "Success",
        "color": "#47d2a5"
      },
      {
        "id": "global-color-245ed",
        "name": "Primary foreground text",
        "color": "#fff"
      },
      {
        "id": "global-color-19df8",
        "name": "Secondary foreground text",
        "color": "#3a6b2f"
      }
    ]
  },
  {
    id: "palette_dark_green",
    name: "Dark Green",
    tags: ["dark"],
    featuredColorsPreview: [
        "global-color-64d5a",
        "global-color-66006",
        "global-color-c4936",
        "global-color-1c32a"
    ],
    colors: [
      {
        "id": "global-color-dc851",
        "name": "Border",
        "color": "#345850"
      },
      {
        "id": "global-color-4c1f0",
        "name": "Light error",
        "color": "#ff525f4d"
      },
      {
        "id": "global-color-2dc58",
        "name": "Error",
        "color": "#ff525f"
      },
      {
        "id": "global-color-108d4",
        "name": "BG",
        "color": "#082522"
      },
      {
        "id": "global-color-1c32a",
        "name": "Background light grey",
        "color": "#133b39"
      },
      {
        "id": "global-color-66006",
        "name": "Neutral primary",
        "color": "#ffffff"
      },
      {
        "id": "global-color-1d200",
        "name": "Neutral secondary",
        "color": "#c1c1c1"
      },
      {
        "id": "global-color-64d5a",
        "name": "Primary",
        "color": "#47d2a5"
      },
      {
        "id": "global-color-c4936",
        "name": "Secondary",
        "color": "#ffffff33"
      },
      {
        "id": "global-color-ad53f",
        "name": "Success",
        "color": "#47d2a5"
      },
      {
        "id": "global-color-245ed",
        "name": "Primary foreground text",
        "color": "#154938"
      },
      {
        "id": "global-color-19df8",
        "name": "Secondary foreground text",
        "color": "#ffffff"
      }
    ]
  },
  {
    id: "palette_dark_purple",
    name: "Dark Purple",
    tags: ["dark"],
    featuredColorsPreview: [
        "global-color-64d5a",
        "global-color-245ed",
        "global-color-1d200",
        "global-color-1c32af"
    ],
    colors:[
      {
        "id": "global-color-dc851",
        "name": "Border",
        "color": "#707070"
      },
      {
        "id": "global-color-4c1f0",
        "name": "Light error",
        "color": "#ff525f33"
      },
      {
        "id": "global-color-2dc58",
        "name": "Error",
        "color": "#ff525f"
      },
      {
        "id": "global-color-108d4",
        "name": "BG",
        "color": "#231536"
      },
      {
        "id": "global-color-1c32a",
        "name": "Background light grey",
        "color": "#3b3063"
      },
      {
        "id": "global-color-66006",
        "name": "Neutral primary",
        "color": "#ffffff"
      },
      {
        "id": "global-color-1d200",
        "name": "Neutral secondary",
        "color": "#c1c1c1"
      },
      {
        "id": "global-color-64d5a",
        "name": "Primary",
        "color": "#ccb4fb"
      },
      {
        "id": "global-color-c4936",
        "name": "Secondary",
        "color": "#ffffff33"
      },
      {
        "id": "global-color-ad53f",
        "name": "Success",
        "color": "#47d2a5"
      },
      {
        "id": "global-color-245ed",
        "name": "Primary foreground text",
        "color": "#321768"
      },
      {
        "id": "global-color-19df8",
        "name": "Secondary foreground text",
        "color": "#ffffff"
      }
    ],
  },
  {
    id: "palette_dark_purple_2",
    name: "Dark Purple 2",
    tags: ["dark"],
    featuredColorsPreview: [
        "global-color-64d5a",
        "global-color-245ed",
        "global-color-1d200",
        "global-color-1c32af"
    ],
    colors: [
      {
        "id": "global-color-dc851",
        "name": "Border",
        "color": "#565389"
      },
      {
        "id": "global-color-4c1f0",
        "name": "Light error",
        "color": "#ff525f33"
      },
      {
        "id": "global-color-2dc58",
        "name": "Error",
        "color": "#ff525f"
      },
      {
        "id": "global-color-108d4",
        "name": "BG",
        "color": "#12112e"
      },
      {
        "id": "global-color-1c32a",
        "name": "Background light grey",
        "color": "#26234e"
      },
      {
        "id": "global-color-66006",
        "name": "Neutral primary",
        "color": "#ffffff"
      },
      {
        "id": "global-color-1d200",
        "name": "Neutral secondary",
        "color": "#c1c1c1"
      },
      {
        "id": "global-color-64d5a",
        "name": "Primary",
        "color": "#5522f5"
      },
      {
        "id": "global-color-c4936",
        "name": "Secondary",
        "color": "#ffffff33"
      },
      {
        "id": "global-color-ad53f",
        "name": "Success",
        "color": "#47d2a5"
      },
      {
        "id": "global-color-245ed",
        "name": "Primary foreground text",
        "color": "#ffffff"
      },
      {
        "id": "global-color-19df8",
        "name": "Secondary foreground text",
        "color": "#ffffff"
      }
    ]
  }, {
    id: "palette_dark_yellow",
    name: "Dark Yellow",
    tags: ["dark"],
    featuredColorsPreview: [
        "global-color-64d5a",
        "global-color-245ed",
        "global-color-1d200",
        "global-color-1c32af"
    ],
    colors: [
      {
        "id": "global-color-dc851",
        "name": "Border",
        "color": "#707070"
      },
      {
        "id": "global-color-4c1f0",
        "name": "Light error",
        "color": "#ff525f33"
      },
      {
        "id": "global-color-2dc58",
        "name": "Error",
        "color": "#ff525f"
      },
      {
        "id": "global-color-108d4",
        "name": "BG",
        "color": "#1b1922"
      },
      {
        "id": "global-color-1c32a",
        "name": "Background light grey",
        "color": "#282828"
      },
      {
        "id": "global-color-66006",
        "name": "Neutral primary",
        "color": "#ffffff"
      },
      {
        "id": "global-color-1d200",
        "name": "Neutral secondary",
        "color": "#c1c1c1"
      },
      {
        "id": "global-color-64d5a",
        "name": "Primary",
        "color": "#fff37b"
      },
      {
        "id": "global-color-c4936",
        "name": "Secondary",
        "color": "#ffffff33"
      },
      {
        "id": "global-color-ad53f",
        "name": "Success",
        "color": "#47d2a5"
      },
      {
        "id": "global-color-245ed",
        "name": "Primary foreground text",
        "color": "#1b1922"
      },
      {
        "id": "global-color-19df8",
        "name": "Secondary foreground text",
        "color": "#ffffff"
      }
    ]
  }
  ];
 